import { APIv1 } from 'src/api'
import { call, put } from 'redux-saga/effects'

import notifyer from 'src/common/notifyer'
import { USER_LIST_CHANGED } from 'src/store/types/adminData'

const deleteUserRequest = (userId: string): Promise<any> => (
  APIv1.delete(`/users/delete/${userId}`)
)

export default function* deleteUser(action: any) {
  try {
    // @ts-ignore
    yield call(deleteUserRequest, action.payload)
    notifyer.success(`User has been deleted`)
    yield put({ type: USER_LIST_CHANGED })
  } catch (e) {
    notifyer.error('Request failed - server error')
  }
}
